import { render, staticRenderFns } from "./TabFormDataPreview.view.vue?vue&type=template&id=3408fb92&"
import script from "./TabFormDataPreview.view.vue?vue&type=script&lang=js&"
export * from "./TabFormDataPreview.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3408fb92')) {
      api.createRecord('3408fb92', component.options)
    } else {
      api.reload('3408fb92', component.options)
    }
    module.hot.accept("./TabFormDataPreview.view.vue?vue&type=template&id=3408fb92&", function () {
      api.rerender('3408fb92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/save/TabFormDataPreview.view.vue"
export default component.exports